import { createContext, useContext, useMemo, useState } from "react";

const HeaderNavContext = createContext({
  headerNav: null,
  setHeaderNav: () => {},
});

export function HeaderNavProvider({ children }) {
  const [headerNav, setHeaderNav] = useState(null);
  const value = useMemo(() => ({ headerNav, setHeaderNav }), [headerNav]);
  return <HeaderNavContext.Provider value={value}>{children}</HeaderNavContext.Provider>;
}

export function useHeaderNav() {
  return useContext(HeaderNavContext);
}

/** Scan screen JSON for a topnavmenu marked headerOnly (JSON-driven per screen). */
export function findHeaderTopNav(screen) {
  if (!screen?.sections) return null;
  for (const sec of screen.sections) {
    const c = sec.controls?.find((x) => x.type === "topnavmenu" && x.headerOnly);
    if (c) {
      return {
        control: c,
        sectionId: sec.id,
        rules: sec.rules || [],
        marquee: screen?.header?.marquee || screen?.marquee || null,
      };
    }
  }
  return {
    control: null,
    sectionId: null,
    rules: [],
    marquee: screen?.header?.marquee || screen?.marquee || null,
  };
}
